export const START_ADDING_COLLECTION_TYPE = 'START_ADDING_COLLECTION_TYPE';
export const START_EDITING_COLLECTION_TYPE = 'START_EDITING_COLLECTION_TYPE';
export const PATCH_COLLECTION_TYPE_FIELD = 'PATCH_COLLECTION_TYPE_FIELD';
